<template>
  <Layout>
    <div v-if='loading' class="mt-5 text-center">
      <b-spinner></b-spinner>
      <h2>Cargando</h2>
    </div>
    <div v-else-if="Object.entries(creditor).length === 0"><ErrorPage></ErrorPage></div>
    <div v-else>
      <b-card class="mt-3">
        <b-row>
          <h3 class="col">Acreedor: {{creditor.name}}</h3><b-col><b-button class="col w-25" @click="$router.go(-1)">Volver</b-button></b-col>
        </b-row>
      </b-card>

      <b-card header="Deudores Actuales">
        <b-table
        id="active-creditor-debtors"
        :items="getActiveDebtors"
        :fields="currentDebtorsFields"
        striped
        class="mb-0"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :busy="isBusy"
        no-sort-reset
        show-empty
        responsive
        >
          <template v-slot:cell(action)="row">
            <b-button  size="sm" :to="'/apps/' + $store.getters['auth/userEntity'] + '/creditor/' + creditor.company_id + '/debtor/' + row.item.debtor_id">
                Perfil Acreedor/Deudor
            </b-button>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>
          </template>
        </b-table>
        <b-card-footer
          style="display:flex; flex-direction: row; justify-content: flex-end;">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="active-creditor-debtors"
            class="mb-0"
          ></b-pagination>
        </b-card-footer>
      </b-card>

      <Invoices table-id='conflicted-invoices' :selected-creditor-id='creditor.company_id' title="Facturas en Conflicto" status='in_conflict'
      :user-email='$store.state.auth.currentUser.data.email'
      hide-creditor-column
      title-variant='danger'
      filters
      @update="getCreditorInfo"
      dont-filter-status
      ></Invoices>
      <Invoices table-id='active-invoices'
      show-admin-status
      :user-email='$store.state.auth.currentUser.data.email'
      :selected-creditor-id='creditor.company_id'
      title="Cobranzas activas"
      status='in_progress'
      title-variant='info'
      filters
      @update="getCreditorInfo"
      hide-creditor-column></Invoices>
      <Invoices table-id='finished-invoices'
      :user-email='$store.state.auth.currentUser.data.email'
      :selected-creditor-id='creditor.company_id'
      title="Cobranzas terminadas"
      status='finished'
      title-variant='success'
      filters
      @update="getCreditorInfo"
      hide-creditor-column></Invoices>

    </div>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import ErrorPage from '@views/pages/secondary/error-404.vue'
import Invoices from '@components/collection_worker/invoices'
import axios from 'axios'
export default {
	page: {
		title: 'Acreedor',
		meta: [{ name: 'description', content: appConfig.description }],
  },
	components: {
    Layout,
    ErrorPage,
    Invoices
  },
	data() {
		return {
      loading: false,
      creditor: {},
      sortBy: "id",
      sortDesc: true,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      isBusy: false,
      currentDebtorsFields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: false,
        },
        {
          key: 'debtor_id',
          label: 'RUT',
          sortable: false,
        },
        {
          key: 'person_type',
          label: 'Tipo Entidad',
          sortable: false,
        },
        {
          key: 'action',
          label: 'Acción',
          sortable: false,
        }
      ]
		}
  },
  computed: {
    userChoice() {
      return this.$store.state.userChoice;
    },
  },
  beforeMount() {
    this.getCreditorInfo()
  },
  methods: {
    async getCreditorInfo() {
      this.loading = true
      try {
        const response = await axios.get(`/api/v1/creditors/info?company_id=${this.$route.params.company_id}`)
        this.creditor =  response.data.company
      } finally {
        this.loading = false
      }
    },
    getActiveDebtors(ctx) {
      this.isBusy = true
      var reqUrl = `/api/v1/debtors/company_debtors?page=${ctx.currentPage}&limit=${ctx.perPage}&sort_by=${ctx.sortBy}&sort_desc=${ctx.sortDesc}&company_id=${this.creditor.company_id}&debt_collection_type=${this.userChoice}`
      var promise = axios.get(reqUrl)
      return promise.then(response => {
        const items = response.data.debtors
        this.totalRows = response.data.meta.total_count
        this.isBusy = false
        return items || []
      }, () => { return []})
    },
  },
}
</script>

<style>

</style>
